import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import type { Nullable } from 'corgi-types';
import { color, fontWeight, space } from 'styled-system';
import type { ColorProps, FontWeightProps, SpaceProps } from 'styled-system';

import BaseCountDown from 'common/components/CountDown';

type CountDownProps = {
  label: string;
  countdownEndDate: Nullable<string>;
};

const InnerCountDown = styled(BaseCountDown)<SpaceProps & ColorProps & FontWeightProps>`
  ${space};
  ${color};
  ${fontWeight};
`;

const innerCountDownStyles: Partial<ComponentProps<typeof InnerCountDown>> = {
  m: 'sp_0',
  pt: 'sp_0',
};

const CountDown = ({ label, countdownEndDate }: CountDownProps) => {
  if (!countdownEndDate) return null;

  return (
    <InnerCountDown
      {...innerCountDownStyles}
      disableMaxWidth
      color="inherit"
      fontSize="inherit"
      lineHeight="inherit"
      fontWeight="inherit"
      flexWrap="nowrap"
      label={label}
      endDate={countdownEndDate}
    />
  );
};

export default CountDown;
